import { ISurveyWidgetSessionPropsLayout } from '../types'

export function layoutIsCompact(layout: ISurveyWidgetSessionPropsLayout) {
  switch (layout) {
    case ISurveyWidgetSessionPropsLayout.COMPACT:
      return true
    case ISurveyWidgetSessionPropsLayout.DEFAULT:
    default:
      return false
  }
}
